<div class="member-upline-container">
  <!-- 頂部搜尋使用者區域 -->
  <div class="top-search-section">
    <div class="search-wrapper">
      <input
        type="text"
        [(ngModel)]="topSearchQuery"
        (keyup.enter)="searchTopUsers()"
        class="top-search-input"
        placeholder="搜尋使用者來查看其上線與下線...">
      <button class="top-search-btn" (click)="searchTopUsers()" type="button">
        🔍 搜尋
      </button>
    </div>

    <!-- 搜尋結果下拉列表 -->
    <div class="top-search-results" *ngIf="showTopSearchResults && topSearchResults.length > 0">
      <div
        class="top-search-result-item"
        *ngFor="let user of topSearchResults"
        (click)="switchToUser(user)">
        <img loading="lazy" [src]="user.profile_pic || user.avatar || 'assets/dist/img/user.png'" class="result-avatar">
        <div class="result-info">
          <div class="result-name">{{ user.name || user.nickname }}</div>
          <div class="result-phone">{{ user.phone }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- 頂部使用者資訊區域 -->
  <div class="header-section">
    <div class="user-info-left">
      <div class="avatar-wrapper">
        <img loading="lazy" [src]="currentUser.avatar || 'assets/dist/img/user.png'" alt="使用者頭像" class="user-avatar">
      </div>
      <div class="user-details">
        <h2 class="user-name">{{ currentUser.name }}</h2>
        <p class="user-email">{{ currentUser.email }}</p>
        <p class="user-phone">{{ currentUser.phone }}</p>
      </div>
    </div>

    <!-- 收益統計 -->
    <div class="revenue-summary">
      <div class="summary-card has-tooltip">
        <div class="summary-label">
          累積總收益
          <span class="info-icon">ⓘ</span>
        </div>
        <div class="summary-value">💎 {{ totalRevenue | number:'1.0-0' }}</div>
        <div class="tooltip-content">
          此數據依靠排程計算<br>不包含當日收益資料
        </div>
      </div>
      <div class="summary-card has-tooltip">
        <div class="summary-label">
          本月收益
          <span class="info-icon">ⓘ</span>
        </div>
        <div class="summary-value monthly">💎 {{ monthlyRevenue | number:'1.0-0' }}</div>
        <div class="tooltip-content">
          此數據依靠排程計算<br>不包含當日收益資料
        </div>
      </div>
      <div class="summary-card">
        <div class="summary-label">本日總收益</div>
        <div class="summary-value daily">💎 {{ todayRevenue | number:'1.2-2' }}</div>
      </div>
    </div>

    <div class="header-right-section">
      <!-- 上線資訊 -->
      <div class="upline-info-card" (click)="switchToUpline()" [class.clickable]="uplineInfo.id && uplineInfo.id !== '-1'">
        <div class="upline-label">我的上線</div>
        <div class="upline-content">
          <img loading="lazy" [src]="uplineInfo.avatar || 'assets/dist/img/user.png'" alt="上線頭像" class="upline-avatar">
          <div class="upline-details">
            <div class="upline-name">{{ uplineInfo.name }}</div>
            <div class="upline-meta">分潤 {{ uplineInfo.commission }}% · 加入 {{ uplineInfo.joinDate }}</div>
          </div>
        </div>
        <div class="click-hint" *ngIf="uplineInfo.id && uplineInfo.id !== '-1'">點擊查看</div>
      </div>

      <!-- 新增按鈕 -->
      <button
        class="btn-add-member"
        (click)="openAddModal()"
        [disabled]="!currentUser.id"
        [title]="!currentUser.id ? '請先搜尋並選擇一個使用者' : '新增下線成員'">
        <span class="btn-icon">+</span>
        新增下線成員
      </button>
    </div>
  </div>

  <!-- 下線成員列表 -->
  <div class="downline-section">
    <div class="section-header">
      <h3 class="section-title">下線成員列表</h3>
      <div class="downline-search-box">
        <input
          type="text"
          [ngModel]="downlineSearchQuery"
          (ngModelChange)="onSearchQueryChange($event)"
          class="downline-search-input"
          placeholder="搜尋下線成員（姓名或ID）...">
        <span class="search-icon" *ngIf="!downlineSearchQuery">🔍</span>
        <button class="clear-search" *ngIf="downlineSearchQuery" (click)="onSearchQueryChange('')" type="button">✕</button>
      </div>
    </div>

    <div class="members-grid" *ngIf="downlineMembers.length > 0">
      <div class="member-card" *ngFor="let member of downlineMembers" (click)="onCardClick(member, $event)">
        <!-- {{ member | json}} -->
        <div class="card-content">
          <div class="member-avatar-wrapper">
            <img loading="lazy" [src]="member.downlineProfilePic || 'assets/dist/img/user.png'" alt="成員頭像" class="member-avatar">
            <span class="status-badge active">
              活躍
            </span>
          </div>

          <div class="member-info">
            <h4 class="member-name">{{ member.downlineName }}</h4>
            <p class="member-detail">
              <span class="label">分潤比例：</span>
              <span class="value">{{ member.downlinePercent }}%</span>
            </p>
            <p class="member-detail">
              <span class="label">加入日期：</span>
              <span class="value">{{ member.downlineCreateDT }}</span>
            </p>
          </div>

          <div class="member-actions">
            <button class="btn-action btn-edit" (click)="openEditModal(member, $event)">編輯</button>
          </div>
        </div>
      </div>
    </div>

    <div class="no-data" *ngIf="downlineMembers.length === 0 && !loading && downlineSearchQuery">
      <p>找不到符合「{{ downlineSearchQuery }}」的下線成員</p>
    </div>

    <div class="no-data" *ngIf="downlineMembers.length === 0 && !loading && !downlineSearchQuery">
      <p>目前無下線成員</p>
    </div>
  </div>

  <!-- 加載更多按鈕（活躍成員） -->
  <div class="load-more-section" *ngIf="downlineMembers.length > 0 && activeHasMore && !loading">
    <button class="btn-load-more" (click)="loadMoreActiveMembers()" [disabled]="isLoadingMoreActive">
      <span *ngIf="!isLoadingMoreActive">加載更多活躍成員</span>
      <span *ngIf="isLoadingMoreActive">加載中...</span>
    </button>
    <div class="load-more-info">
      已顯示 {{ downlineMembers.length }} / {{ activeTotalCount }} 筆活躍成員
    </div>
  </div>

  <!-- 全部加載完成提示（活躍成員） -->
  <div class="all-loaded" *ngIf="downlineMembers.length > 0 && !activeHasMore && !loading">
    <p>✓ 已顯示全部 {{ downlineMembers.length }} 筆活躍成員</p>
  </div>

  <!-- 歷史下線成員列表 -->
  <div class="downline-section historical-section" *ngIf="historicalDownlineMembers.length > 0">
    <h3 class="section-title">歷史下線成員</h3>

    <div class="members-grid">
      <div class="member-card historical" *ngFor="let member of historicalDownlineMembers" (click)="onCardClick(member, $event)">
        <div class="card-content">
          <div class="member-avatar-wrapper">
            <img loading="lazy" [src]="member.downlineProfilePic || 'assets/dist/img/user.png'" alt="成員頭像" class="member-avatar">
            <span class="status-badge inactive">
              停用
            </span>
          </div>

          <div class="member-info">
            <h4 class="member-name">{{ member.downlineName }}</h4>
            <p class="member-detail">
              <span class="label">分潤比例：</span>
              <span class="value">{{ member.downlinePercent }}%</span>
            </p>
            <p class="member-detail">
              <span class="label">加入日期：</span>
              <span class="value">{{ member.downlineCreateDT }}</span>
            </p>
            <p class="member-detail">
              <span class="label">結束日期：</span>
              <span class="value">{{ member.downlineEndDT || '-' }}</span>
            </p>
          </div>

          <div class="member-actions">
            <button class="btn-action btn-view" (click)="openEditModal(member, $event)">查看</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 加載更多按鈕（歷史成員） -->
    <div class="load-more-section" *ngIf="historicalDownlineMembers.length > 0 && historyHasMore && !loading">
      <button class="btn-load-more" (click)="loadMoreHistoryMembers()" [disabled]="isLoadingMoreHistory">
        <span *ngIf="!isLoadingMoreHistory">加載更多歷史成員</span>
        <span *ngIf="isLoadingMoreHistory">加載中...</span>
      </button>
      <div class="load-more-info">
        已顯示 {{ historicalDownlineMembers.length }} / {{ historyTotalCount }} 筆歷史成員
      </div>
    </div>

    <!-- 歷史成員全部加載完成提示 -->
    <div class="all-loaded historical" *ngIf="historicalDownlineMembers.length > 0 && !historyHasMore && !loading">
      <p>✓ 已顯示全部 {{ historicalDownlineMembers.length }} 筆歷史成員</p>
    </div>
  </div>
</div>

<!-- 新增成員 Modal -->
<div class="modal-overlay" *ngIf="showAddModal" (click)="closeAddModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>新增下線成員</h3>
      <button class="modal-close" (click)="closeAddModal()">&times;</button>
    </div>
    <div class="modal-body">
      <!-- 搜尋成員 -->
      <div class="form-group">
        <label>搜尋成員（姓名或手機）</label>
        <div class="search-input-wrapper">
          <input
            type="text"
            [(ngModel)]="searchQuery"
            (keyup.enter)="searchUsers()"
            class="form-input search-input"
            placeholder="輸入姓名或手機號碼搜尋..."
            [disabled]="selectedUser">
          <button
            *ngIf="!selectedUser"
            class="search-action-btn"
            (click)="searchUsers()"
            type="button">
            🔍 搜尋
          </button>
          <button
            *ngIf="selectedUser"
            class="clear-search-btn"
            (click)="clearSelection()"
            type="button">
            ✕ 清除
          </button>
        </div>

        <!-- 搜尋結果列表 -->
        <div class="search-results" *ngIf="filteredUserList.length > 0">
          <div
            class="search-result-item"
            *ngFor="let user of filteredUserList"
            (click)="selectUser(user)">
            <!-- {{ user | json}} -->
            <!-- {{ user.avatar | json }} -->
            <img loading="lazy" [src]="user.profile_pic || 'assets/dist/img/user.png'" class="result-avatar">
            <div class="result-info">
              <div class="result-name">{{ user.name }}</div>
              <div class="result-phone">{{ user.phone }}</div>
            </div>
          </div>
        </div>

        <!-- 已選擇的成員 -->
        <div class="selected-user-card" *ngIf="selectedUser">
          <img loading="lazy" [src]="selectedUser.profile_pic || 'assets/dist/img/user.png'" class="selected-avatar">
          <div class="selected-info">
            <div class="selected-name">{{ selectedUser.name }}</div>
            <div class="selected-phone">{{ selectedUser.phone }}</div>
          </div>
        </div>
      </div>

      <!-- 其他設定（只在選擇成員後顯示） -->
      <div *ngIf="selectedUser">
        <div class="form-group">
          <label>分潤比例 (%)</label>
          <input type="number" [(ngModel)]="editData.commission" class="form-input" placeholder="請輸入分潤比例" step="0.1" min="3" max="40">
          <small class="form-hint">比例範圍：3% ~ 40%</small>
        </div>
        <div class="form-group">
          <label>加入日期</label>
          <input type="date" [(ngModel)]="editData.joinDate" class="form-input" disabled>
        </div>
        <!-- <div class="form-group"> -->
          <!-- <label>狀態</label> -->
          <!-- <div class="status-toggle"> -->
            <!-- <button [class.active]="editData.status === 1" (click)="editData.status = 1" class="status-btn" disabled>活躍</button> -->
            <!-- <button [class.active]="editData.status === 0" (click)="editData.status = 0" class="status-btn" disabled>停用</button> -->
          <!-- </div> -->
        <!-- </div> -->
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn modal-btn-cancel" (click)="closeAddModal()">取消</button>
      <button class="modal-btn modal-btn-confirm" (click)="confirmAdd()">確認新增</button>
    </div>
  </div>
</div>

<!-- 編輯成員 Modal -->
<div class="modal-overlay" *ngIf="showEditModal" (click)="closeEditModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ isHistoricalMember ? '查看歷史下線成員' : '編輯下線成員' }}</h3>
      <button class="modal-close" (click)="closeEditModal()">&times;</button>
    </div>
    <div class="modal-body">
      <!-- 歷史成員提示 -->
      <div class="historical-notice" *ngIf="isHistoricalMember">
        <p>⚠️ 此成員為歷史下線成員，無法進行編輯操作</p>
      </div>

      <!-- 成員資訊顯示 -->
      <div class="edit-member-info">
        <img loading="lazy" [src]="editData.avatar || 'assets/dist/img/user.png'" class="edit-member-avatar">
        <div class="edit-member-details">
          <div class="edit-member-name">{{ editData.name }}</div>
          <div class="edit-member-id">ID: {{ editData.id }}</div>
        </div>
      </div>

      <div class="form-group">
        <label>分潤比例 (%)</label>
        <input type="number" [(ngModel)]="editData.commission" class="form-input" placeholder="請輸入分潤比例" step="0.1" min="3" max="40" [disabled]="isHistoricalMember">
        <small class="form-hint">比例範圍：3% ~ 40%</small>
      </div>
      <div class="form-group">
        <label>加入日期</label>
        <input type="date" [(ngModel)]="editData.joinDate" class="form-input" disabled>
      </div>
      <!-- <div class="form-group"> -->
        <!-- <label>狀態</label> -->
        <!-- <div class="status-toggle"> -->
          <!-- <button [class.active]="editData.status === 1" class="status-btn" disabled>活躍</button> -->
          <!-- <button [class.active]="editData.status === 0" class="status-btn" disabled>停用</button> -->
        <!-- </div> -->
      <!-- </div> -->
    </div>
    <div class="modal-footer modal-footer-split" *ngIf="!isHistoricalMember">
      <button class="modal-btn modal-btn-danger" (click)="openDeleteModal(editData); closeEditModal()">刪除成員</button>
      <div class="modal-footer-right">
        <button class="modal-btn modal-btn-cancel" (click)="closeEditModal()">取消</button>
        <button class="modal-btn modal-btn-confirm" (click)="confirmEdit()">確認修改</button>
      </div>
    </div>
    <div class="modal-footer" *ngIf="isHistoricalMember">
      <button class="modal-btn modal-btn-cancel" (click)="closeEditModal()">關閉</button>
    </div>
  </div>
</div>

<!-- 刪除確認 Modal -->
<div class="modal-overlay" *ngIf="showDeleteModal" (click)="closeDeleteModal()">
  <div class="modal-container modal-small" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>確認刪除</h3>
      <button class="modal-close" (click)="closeDeleteModal()">&times;</button>
    </div>
    <div class="modal-body">
      <p class="delete-confirm-text">確定要刪除成員「{{ deleteTarget?.downlineName || deleteTarget?.name }}」嗎？</p>
      <p class="delete-warning">此操作無法復原</p>
    </div>
    <div class="modal-footer">
      <button class="modal-btn modal-btn-cancel" (click)="closeDeleteModal()">取消</button>
      <button class="modal-btn modal-btn-danger" (click)="confirmDelete()">確認刪除</button>
    </div>
  </div>
</div>

<!-- 收益詳情 Modal -->
<div class="modal-overlay" *ngIf="showRevenueModal" (click)="closeRevenueModal()">
  <div class="modal-container modal-large" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="history-header-info">
        <img loading="lazy"
          [src]="selectedMember?.downlineProfilePic || selectedMember?.profile_pic || 'assets/dist/img/user.png'"
          class="history-avatar clickable-avatar"
          *ngIf="selectedMember"
          (click)="switchToMemberFromRevenue()"
          title="點擊切換到此成員">
        <div>
          <h3>{{ selectedMember?.downlineName || selectedMember?.name }} - 收益詳情</h3>
          <p class="history-subtitle">分潤比例：{{ selectedMember?.downlinePercent || selectedMember?.percent }}%</p>
        </div>
      </div>
      <button class="modal-close" (click)="closeRevenueModal()">&times;</button>
    </div>
    <div class="modal-body">
      <!-- 總覽卡片 -->
      <div class="revenue-summary">
        <div class="summary-card">
          <div class="summary-label">累計總收益</div>
          <div class="summary-value">💎 {{ revenueData.totalRevenue | number }}</div>
        </div>
        <div class="summary-card">
          <div class="summary-label">本月收益</div>
          <div class="summary-value monthly">💎 {{ revenueData.monthlyRevenue | number }}</div>
        </div>
      </div>

      <!-- 歷史收益表格 -->
      <div class="revenue-history">
        <div class="revenue-history-header">
          <h4 class="revenue-history-title">近期收益明細</h4>
          <div class="view-mode-toggle">
            <button
              class="toggle-btn"
              [class.active]="revenueViewMode === 'monthly'"
              (click)="toggleRevenueViewMode('monthly')">
              按月
            </button>
            <button
              class="toggle-btn"
              [class.active]="revenueViewMode === 'daily'"
              (click)="toggleRevenueViewMode('daily')">
              按日
            </button>
          </div>
        </div>

        <div class="revenue-table">
          <!-- 按月顯示 -->
          <div *ngIf="revenueViewMode === 'monthly'">
            <div class="revenue-table-header">
              <div class="revenue-col">月份</div>
              <div class="revenue-col">收益金額</div>
            </div>
            <div class="revenue-table-row" *ngFor="let item of revenueData.revenueHistory">
              <div class="revenue-col">{{ item.month }}</div>
              <div class="revenue-col revenue-amount">💎 {{ item.revenue | number }}</div>
            </div>
          </div>

          <!-- 按日顯示 -->
          <div *ngIf="revenueViewMode === 'daily'">
            <div class="revenue-table-header">
              <div class="revenue-col">日期</div>
              <div class="revenue-col">收益金額</div>
            </div>
            <div class="revenue-table-row" *ngFor="let item of revenueData.revenueHistory">
              <div class="revenue-col">{{ item.date }}</div>
              <div class="revenue-col revenue-amount">💎 {{ item.revenue | number }}</div>
            </div>
          </div>

          <!-- 無數據提示 -->
          <div class="no-revenue-data" *ngIf="revenueData.revenueHistory.length === 0">
            <p>暫無收益紀錄</p>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="modal-btn modal-btn-secondary" (click)="viewHistoryFromRevenue()">查看編輯紀錄</button>
      <button class="modal-btn modal-btn-cancel" (click)="closeRevenueModal()">關閉</button>
      <button class="modal-btn modal-btn-confirm" (click)="openEditFromRevenue()">編輯成員</button>
    </div>
  </div>
</div>

<!-- 歷史編輯紀錄 Modal -->
<div class="modal-overlay" *ngIf="showHistoryModal" (click)="closeHistoryModal()">
  <div class="modal-container modal-large" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="history-header-info">
        <img loading="lazy" [src]="selectedMember?.avatar || 'assets/dist/img/user.png'" class="history-avatar" *ngIf="selectedMember">
        <div>
          <h3>{{ selectedMember?.name }} - 編輯歷史紀錄</h3>
          <p class="history-subtitle">共 {{ editHistory.length }} 筆紀錄</p>
        </div>
      </div>
      <button class="modal-close" (click)="closeHistoryModal()">&times;</button>
    </div>
    <div class="modal-body history-body">
      <div class="history-timeline" *ngIf="editHistory.length > 0">
        <div class="history-item" *ngFor="let record of editHistory; let i = index">
          <div class="history-dot"></div>
          <div class="history-line" *ngIf="i < editHistory.length - 1"></div>
          <div class="history-content">
            <div class="history-time">{{ record.editTime }}</div>
            <div class="history-card">
              <div class="history-header-row">
                <span class="history-editor">
                  <span class="editor-icon">👤</span>
                  {{ record.editor }}
                </span>
                <span class="history-field-badge">{{ record.field }}</span>
              </div>
              <div class="history-change">
                <div class="change-item old-value">
                  <span class="change-label">修改前</span>
                  <span class="change-value">{{ record.oldValue }}</span>
                </div>
                <div class="change-arrow">→</div>
                <div class="change-item new-value">
                  <span class="change-label">修改後</span>
                  <span class="change-value">{{ record.newValue }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-history" *ngIf="editHistory.length === 0">
        <p>尚無編輯紀錄</p>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn modal-btn-cancel" (click)="closeHistoryModal()">關閉</button>
    </div>
  </div>
</div>

<app-spinner [loading]="loading"></app-spinner>
